import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/manufacturers.js';
import form from '../forms/manufacturers.js';
import * as types from '../types.js';

const manufacturers = function()
{

	let manufacturers_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_manufacturers, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_manufacturer, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				nick: data.nick,
				name: data.name
			};
			if (old_data)
				return await api.call(api.update_manufacturer, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_manufacturer, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Classe', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do fabricante' },
		{ index: 3, field: 'nick', label: 'Apelido', types: [], placeholder: '', title: 'Nome curto para o fabricante' },
		{ index: 4, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Razão social do fabricante' },
	];

	manufacturers_crud.run(
		'manufacturers',
		'Fabricantes',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default manufacturers;

